/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable */
import _, { cloneDeep } from 'lodash';
// eslint-disable-next-line object-curly-newline
import { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { formActions, productActions } from '../../../Actions';
import { useAuth } from '../../../Components/Auth/Login/auth';
import ProductDetails from '../../../Components/Forms/Products/ProductDetails';
import { ViewPageHeader } from '../../../Components/Headers';
import {
	StyledTabs,
	StyledTab,
	TabPanel,
} from '../../../Components/StyledTabs';
import { history, isEmpty } from '../../../Helpers';
import productConfig from './allproduct.config';
import ProductVariantsTable from '@/Components/Forms/Products/ProductVariantsTable';
import ProductQualityConfig from '@/Components/Forms/Products/ProductQualityConfig';
import { FormSectionHeader } from '@/Components/Forms';
import { qualityConfig } from './quality.config';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import { notificationServices } from '@/Services';
import authActions from '@/Actions/auth.actions';
import { Label } from '@/Components/ui/label';
import QualityCheck from '@/Components/AddProductParameters/qualityCheck';
import AddParameterComp from '@/Components/AddProductParameters/addParameterComp';
import { Checkbox } from '@mui/material';
import masterMenuServices from '@/Services/ProductSpecificationParamServices/productMasterMenu.services';
import QualityConfig from '@/Components/AddProductParameters/qualityConfig';
import Accompaniments from '../Accompaniments/Accompaniments';
import variantBatchSizeServices from '@/Services/variantBatchSize.services';
import PoTableMultiple from '@/Components/POTableMultiple/poTable';
import { BackdropLoader } from '@/Components/Loaders';

const TABS = ['PRODUCT DETAILS'];

const ProductViewPage = (props) => {
	const { appConfig = {} } = useAuth();
	const { measurement } = appConfig?.configs ?? {};
	const {
		fetchProduct,
		data,
		deleteProduct,
		breadcrumbs,
		subCategoriesList,
		fetchVariant,
		fetchSubCategories,
		variantData,
		qualityData,
		userPermissions,
		navState,
		userList,
		fetchUserList,
		fetchStoresList,
		stores,
	} = props;
	const dispatch = useDispatch();
	const products = useSelector((state) => state.product.products);

	useEffect(() => {
		dispatch(productActions.fetchProducts());
	}, []);

	const [productData, setProductData] = useState({});
	const [state, setState] = useState({
		activeTab: 0,
		fields: _.cloneDeep(productConfig.initialState.fields),
	});
	const [variant, setVariantData] = useState({
		fields: cloneDeep(productConfig.initialState?.fields?.variants),
	});
	const [newList, setNewList] = useState([]);
	const [qualityCheck, setQualityCheck] = useState({
		qualityCheckEnabled: false,
		categoryConfiguration: false,
		minSamplingQuantity: 0,
		weightCheck: false,
		temperatureCheck: {
			enabled: false,
			minTemp: 0,
			maxTemp: 0,
		},
		defectCheck: {
			enabled: false,
			areaThreshold: 0,
			countThreshold: 0,
			reject: 'both',
		},
		scanCount: 0,
	});
	const { id } = useRouteMatch().params;

	// Batch Size Section States
	const [batchSizeLoading, setBatchSizeLoading] = useState(false);
	const [batchSizeState, setBatchSizeState] = useState({});
	const [batchSizeHeaders, setBatchSizeHeaders] = useState([]);
	const [selectedStoreIds, setSelectedStoreIds] = useState([]);

	// Fetch stores list for header names
	useEffect(() => {
		fetchStoresList({
			entity: 'STORES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	const { userConfig = {} } = useAuth();
	// userAcess
	// useEffect(async () => {
	// 	fetchUserList();
	// }, []);
	// const map = new Map(userList.map((item) => [item.value, item.label]));
	// const role = Object.keys(userConfig?.userRoles);
	// const userRoles = [];
	// role.forEach((ele) => {
	// 	userRoles.push(ele);
	// });
	// const pageRole = navState['/products']?.submenu['/products/all']?.rolesMapped;
	// const findMatchingRole = userRoles.filter((ele) => pageRole.includes(Number(ele)));
	// const roleDetails = findMatchingRole.map((role) => {
	// 	const key = Number(role);
	// 	const name = map.get(key);
	// 	return {
	// 		role: key, name,
	// 	};
	// });
	// const isInternal = roleDetails.some((item) => item.name === 'Production' || item.name === 'Procurement' || item.name === 'Distribution And Supply Chain');
	// const access = findMatchingRole.length > 0 ? userConfig?.userDetails?.level : false;
	// let permit;
	// if (access === false) {
	// 	permit = false;
	// } else {
	// 	permit = isInternal && access !== 1;
	// }
	// end user Acces

	const fetchProductData = async () => {
		try {
			const req = {
				params: {
					productId: id,
				},
			};
			const response = await masterMenuServices.fetchProductData(req);
			if (response?.statusCode === 200) {
				setProductData(response?.data);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Error fetching product data',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message,
			});
		}
	};
	useEffect(() => {
		fetchProductData();
		// fetchProduct({
		// 	entity: 'ALL_PRODUCTS',
		// 	req: {
		// 		params: {
		// 			id,
		// 		},
		// 	},
		// 	method: 'VIEW',
		// });

		// fetchVariant({
		// 	entity: 'VARIANTS',
		// 	req: {
		// 		params: {
		// 			id,
		// 		},
		// 	},
		// 	method: 'VIEW',
		// 	showNotification: true,
		// });
		// fetchProduct({
		// 	entity: 'PRODUCT_QUALITY_CONFIG',
		// 	req: {
		// 		params: {
		// 			id,
		// 			combo: true,
		// 		},
		// 	},
		// 	method: 'LIST',
		// });
	}, []);

	useEffect(() => {
		const newState = {};
		if (!isEmpty(productData)) {
			setState(
				productConfig.serializer(
					state,
					{
						...productData,
						measurement,
						densityUnit: measurement === 'US' ? 'Lb' : 'Kg',
					},
					products
				)
			);
			setVariantData(
				productConfig?.variantSerilizer(productData, products)
			);
			newState.qualityCheckEnabled =
				productData?.qualityAnalysis?.qualityAnalysisEnabled;
			newState.categoryConfiguration =
				productData?.qualityAnalysis?.ifCategoryConfig;
			newState.minSamplingQuantity =
				productData?.qualityAnalysis?.minimumSamplingQuantityPercentage;
			newState.weightCheck =
				productData?.qualityAnalysis?.weightCheckRequired;
			newState.temperatureCheck =
				productData?.qualityAnalysis?.temperatureCheckRequired;
			newState.scanCount = productData?.qualityAnalysis?.maxScanCount;
			newState.defectCheck = {
				enabled: productData?.qualityAnalysis?.defectConfig?.enabled,
				areaThreshold:
					productData?.qualityAnalysis?.defectConfig?.areaThreshold ||
					0.1,
				countThreshold:
					productData?.qualityAnalysis?.defectConfig
						?.countThreshold || 1,
				reject: productData?.qualityAnalysis?.defectConfig?.reject,
			};
			setQualityCheck(newState);
			setNewList(productData?.qualityAnalysis?.parameterChecks);
		}
		// if (!isEmpty(data)) {
		// 		setState(
		// 			productConfig.serializer(state, {
		// 			...data,
		// 			measurement,
		// 			densityUnit: measurement === 'US' ? 'Lb' : 'Kg',
		// 		})
		// 	);
		// }
		// if (!isEmpty(variantData)) {
		// 	setVariantData(productConfig?.variantSerilizer(variantData));
		// }
		// if (quality) {
		// 	setQualityFields(qualityConfig.serializer(state, quality));
		// }
	}, [productData, id]);

	useEffect(() => {
		if (state?.fields?.category) {
			fetchSubCategories({
				entity: 'PRODUCT_SUB_CATEGORY',
				req: {
					params: {
						categoryId: state?.fields?.category,
					},
				},
				method: 'LIST',
			});
		}
	}, [state?.fields?.category]);

	// Unit conversion mapping for batch size display
	const UNIT_CONVERSION_MAP = {
		gram: { displayUnit: 'kg', multiplier: 1000 },
		gm: { displayUnit: 'kg', multiplier: 1000 },
		g: { displayUnit: 'kg', multiplier: 1000 },
		ml: { displayUnit: 'ltr', multiplier: 1000 },
		milliliter: { displayUnit: 'ltr', multiplier: 1000 },
		millilitre: { displayUnit: 'ltr', multiplier: 1000 },
		count: { displayUnit: 'pcs', multiplier: 1 },
	};

	const getDisplayUnit = (unit) => {
		if (!unit) return unit;
		const lowerUnit = unit.toLowerCase();
		return UNIT_CONVERSION_MAP[lowerUnit]?.displayUnit || unit;
	};

	const convertToDisplayValue = (value, unit) => {
		if (value === '' || value === null || value === undefined) return '';
		if (!unit) return value;
		const lowerUnit = unit.toLowerCase();
		const conversion = UNIT_CONVERSION_MAP[lowerUnit];
		if (conversion) {
			return Number(value) / conversion.multiplier;
		}
		return value;
	};

	// Get product variants for batch size section
	const productVariants = useMemo(() => {
		if (!productData?.variants) return [];
		return productData?.variants?.map((variant) => ({
			...variant,
			productName: productData?.productName,
			variantName: variant?.displayName || variant?.variantName,
			productNameDisplay: `${productData?.productName} (${
				variant?.displayName || variant?.variantName
			})`,
			variantId: variant?.id,
			clientVariantId: variant?.clientVariantId,
			unit: variant?.unit,
		}));
	}, [productData]);

	// Fetch batch size data for product variants
	const fetchBatchSizeData = async () => {
		if (!productVariants?.length) return;

		setBatchSizeLoading(true);
		try {
			const response = await variantBatchSizeServices.getBatchSizeList();
			if (
				response?.statusCode === 200 ||
				response?.status === 'Success'
			) {
				const batchSizesData = response?.data?.batchSizes || {};
				const variantIds = productVariants.map((v) => v.variantId);
				const allMappings = {};
				const storeIdsSet = new Set();

				// Filter only variants belonging to this product
				Object.entries(batchSizesData).forEach(
					([variantId, typeData]) => {
						const numericVariantId = Number(variantId);
						if (!variantIds.includes(numericVariantId)) return;

						allMappings[numericVariantId] = {};
						const productForVariant = productVariants.find(
							(p) => p.variantId === numericVariantId
						);
						const productUnit = productForVariant?.unit;

						Object.entries(typeData).forEach(([key, data]) => {
							const displayValue = convertToDisplayValue(
								data?.value,
								productUnit
							);
							allMappings[numericVariantId][key.toUpperCase()] = {
								type: data?.type?.toUpperCase() || 'STORE',
								id: data?.id || 0,
								value: displayValue,
								access: data?.access,
							};

							if (
								data?.type?.toUpperCase() === 'STORE' &&
								data?.id
							) {
								storeIdsSet.add(data?.id);
							}
						});
					}
				);

				setBatchSizeState(allMappings);
				setSelectedStoreIds(Array.from(storeIdsSet));
			}
		} catch (error) {
			console.error('Error fetching batch size data:', error);
		} finally {
			setBatchSizeLoading(false);
		}
	};

	useEffect(() => {
		if (productVariants?.length > 0) {
			fetchBatchSizeData();
		}
	}, [productVariants]);

	// Generate headers for batch size table
	useEffect(() => {
		const storeHeaders = selectedStoreIds.map((storeId) => {
			// Find store name from stores list
			const storeFromList = stores?.find((s) => s?.id === storeId);
			const storeName = storeFromList?.name || `Store ${storeId}`;
			return {
				colName: storeName,
				id: storeId,
				type: 'STORE',
				subCols: [],
			};
		});

		const headerData = [
			{ colName: 'Item Name', subCols: [] },
			{ colName: 'Default', id: 0, type: 'ROOT', subCols: [] },
			...storeHeaders,
		];

		setBatchSizeHeaders(headerData);
	}, [selectedStoreIds, stores]);

	// Transform data for PoTableMultiple
	const batchSizeTableData = useMemo(() => {
		if (!batchSizeHeaders?.length || !productVariants?.length) {
			return { headers: [], rows: [] };
		}

		// Only show variants that have batch size data
		const variantsWithBatchData = productVariants.filter(
			(variant) => batchSizeState[variant.variantId]
		);

		if (!variantsWithBatchData.length) {
			return { headers: [], rows: [] };
		}

		const transformedHeaders = batchSizeHeaders.map((header) => ({
			name: header?.colName,
			id: header?.id ?? header?.colName,
			type: header?.type,
			isUnit: header?.colName === 'Unit',
		}));

		const transformedRows = variantsWithBatchData.map((item) => {
			const originalUnit = item?.unit;
			const displayUnit = getDisplayUnit(originalUnit);
			return {
				...item,
				'Item Name': `${item?.productName} (${item?.variantName})`,
				// 'SKU Code': item?.clientVariantId || '-',
				// Unit: displayUnit,
				originalUnit: originalUnit,
			};
		});

		return {
			headers: transformedHeaders,
			rows: transformedRows,
		};
	}, [batchSizeHeaders, productVariants, batchSizeState]);

	// Render cell data for batch size table
	const renderBatchSizeCellData = (rowData, rowIndex, header) => {
		if (header?.name === 'Item Name') {
			return (
				<div className='w-full text-left text-[12px] flex gap-2 items-center p-1'>
					{rowData?.['Item Name']}
				</div>
			);
		}

		if (header?.name === 'SKU Code') {
			return (
				<div className='w-full text-center text-[12px] p-1 font-medium text-gray-600'>
					{rowData?.['SKU Code']}
				</div>
			);
		}

		if (header?.name === 'Unit') {
			return (
				<div style={{ fontWeight: 600, textAlign: 'center' }}>
					{rowData?.Unit}
				</div>
			);
		}

		// Handle batch size columns (Default and Store columns)
		const variantId = rowData?.variantId;
		const type = header?.type;
		const headerId = header?.id;
		const flatItemData =
			batchSizeState?.[variantId]?.[`${type}-${headerId}`];
		const displayValue = flatItemData?.value ?? '-';

		return (
			<div className='w-full text-center text-[12px] p-1 font-medium'>
				{displayValue !== '' && displayValue !== '-'
					? displayValue
					: '-'}
			</div>
		);
	};

	const { activeTab, fields } = state;

	const handleTabChange = (event, tab) => {
		setState({
			...state,
			activeTab: tab,
		});
	};

	const excludedFields = useMemo(() => {
		let exclude = {};
		const productUnit = state?.fields?.productUnits?.reduce(
			(finalUnit, currUnit) => {
				if (currUnit?.isApplied) {
					return currUnit?.id;
				}
				return finalUnit;
			}
		);

		if (
			productUnit === 'litre' ||
			productUnit === 'ml' ||
			productUnit === 'floz'
		) {
			exclude = {};
		} else {
			exclude.productDensity = true;
		}
		return exclude;
	}, [state?.fields?.productUnits]);

	const renderInfo = (idx) => {
		switch (idx) {
			case 0:
				return (
					<>
						<ProductDetails
							isDisabled
							fields={fields}
							exclude={excludedFields}
							subCategoriesList={subCategoriesList}
							isUnitChange={true}
						/>
						<div className='w-full flex justify-end'>
							<div className='w-[80%]'>
								<Accompaniments
									modalMode='PRODUCT_VARIANTS'
									groups={{
										ACCOMPANIMENTS: {
											choices: [],
										},
									}}
									accompanimentsData={
										state?.fields?.accompaniments
									}
									isDisabled={true}
								/>
							</div>
						</div>
						{/* <ProductTags
							fields={fields}
							menuTags={productConfig.initialState.menuTags}
							productTags={productConfig.initialState.productTags}
							isDisabled
						/> */}
						<FormSectionHeader
							tooltip='description for the section'
							sectionName='Varients Details'
						>
							<ProductVariantsTable
								isDisabled
								measurement={measurement}
								unitprop={variant?.fields}
								variants={variant?.fields?.variants}
							/>
						</FormSectionHeader>

						<div className='flex gap-2 m-[1rem] mt-4 justify-between'>
							<div className='flex item-center'>
								<Label className='text-lg text-gray-600 font-medium'>
									Quality Analysis Inspection
								</Label>
							</div>
							{/* <div className='flex items-center gap-2'>
								<Checkbox
									checked={qualityCheck?.categoryConfiguration}
									onChange={() => setQualityCheck((prev) => ({...prev, categoryConfiguration : !prev.categoryConfiguration}))} 
									size="small"
									sx={{
										'& .MuiSvgIcon-root': {
										fontSize: '1.2rem',
										},
										'&.Mui-checked': {
										color: '#000000',
										},
									}}
									disabled
								/>
								<Label className='text-lg text-gray-600 font-medium'>Follow Category Configuration</Label>
							</div> */}
						</div>
						<QualityConfig
							qualityCheck={qualityCheck}
							setQualityCheck={setQualityCheck}
							pageName='Product'
							isDisabled
							unit={
								state?.fields?.productUnits.find(
									(unit) => unit.isApplied === true
								)?.id
							}
						/>
						<div
							className={`transition-all duration-700 ease-in-out transform origin-top ${
								qualityCheck?.qualityCheckEnabled
									? 'max-h-[500px] scale-y-100 opacity-100'
									: 'max-h-[0px] scale-y-0 opacity-0'
							}`}
						>
							<QualityCheck
								qualityCheck={qualityCheck}
								setQualityCheck={setQualityCheck}
								pageName='Product'
								isDisabled
							/>
							<AddParameterComp
								selectedParameters={newList}
								setNewList={setNewList}
								qualityCheck={qualityCheck}
								isDisabled
								hideCategoryConfiguration
							/>
						</div>

						{/* <FormSectionHeader
							tooltip='description for the section'
							sectionName='Quality Config'
						>
							<ProductQualityConfig
								fields={qualityFields?.fields}
								isDisabled
							/>
						</FormSectionHeader> */}

						{/* Variant Batch Size Based on Kitchens Section */}
						<FormSectionHeader
							tooltip='View variant batch sizes configured for different Kitchens'
							sectionName='Variant Batch Size Based on Kitchens'
						>
							<div className='relative'>
								<BackdropLoader
									showProgress
									isLoading={batchSizeLoading}
								/>
								{batchSizeTableData?.headers?.length > 0 &&
								batchSizeTableData?.rows?.length > 0 ? (
									<div className='bg-white rounded-lg border border-gray-100'>
										<PoTableMultiple
											tableData={batchSizeTableData}
											renderCellData={
												renderBatchSizeCellData
											}
											fixedColumns={['Item Name']}
											columnWidth={150}
										/>
									</div>
								) : (
									<div className='flex justify-center items-center h-[150px] bg-gray-50 rounded-lg border border-gray-200'>
										<p className='text-gray-500 text-sm italic'>
											{batchSizeLoading
												? 'Loading batch size data...'
												: 'No batch size data available for this product'}
										</p>
									</div>
								)}
							</div>
						</FormSectionHeader>
					</>
				);
			default:
				return <></>;
		}
	};
	const { url } = useRouteMatch();

	const redirectToEdit = () => {
		const splitURL = url.split('/view');
		splitURL.splice(1, 0, '/edit');
		const newURL = splitURL.join('');
		history.push(newURL);
	};

	const handleDelete = () => {
		const splitURL = url.split('/view');
		deleteProduct({
			entity: 'ALL_PRODUCTS',
			req: {
				params: {
					id,
				},
			},
			method: 'DELETE',
		});
		history.push(splitURL[0]);
	};
	return (
		<div className='root'>
			<ViewPageHeader
				heading='View Product'
				handleEdit={redirectToEdit}
				handleDelete={handleDelete}
				breadcrumbs={[
					...breadcrumbs,
					{
						link: '',
						name: `View ${fields.name}`,
					},
				]}
				showBreadcrumbs
			/>
			<StyledTabs value={activeTab} onChange={handleTabChange}>
				{TABS.map((tab) => {
					return <StyledTab label={tab} />;
				})}
			</StyledTabs>
			{TABS.map((tab, idx) => {
				return (
					<TabPanel value={activeTab} index={idx}>
						{renderInfo(idx)}
					</TabPanel>
				);
			})}
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.ALL_PRODUCTS.data.VIEW;
	const variantData = state.form.VARIANTS.data.VIEW;
	const subCategoriesList = state.form.PRODUCT_SUB_CATEGORY.data.LIST;
	const qualityData = state.form.PRODUCT_QUALITY_CONFIG.data.LIST;
	const stores = state?.form?.STORES?.data?.LIST;
	const { userPermissions, navState } = state.navigation;
	const { userList } = state.auth;
	return {
		data,
		variantData,
		subCategoriesList,
		qualityData,
		userPermissions,
		navState,
		userList,
		stores,
	};
};

const mapDispatchToProps = {
	fetchProduct: formActions.gateway,
	deleteProduct: formActions.gateway,
	fetchSubCategories: formActions.gateway,
	fetchVariant: formActions.gateway,
	fetchUserList: authActions?.fetchUserList,
	fetchStoresList: formActions.gateway,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductViewPage);
